import React, { useContext, useEffect, useRef } from "react";
import { Redirect } from "react-router-dom";
import AppContext from "../appContext";
import Back from "../main/back";
import { TokenUtils } from "../shared/utils/TokenUtils";
import { redirectPage } from "../components/utils/redirectpage";
import useRepondeur from "./use-repondeur";
import { acessoLiberado } from "./repondeur-utils";
import ChatWindow from "./chat-window";
import logoResponde from "./img/logo-conecta-responde.svg";
import "./repondeur.css";

const Repondeur = () => {
	const context = useContext(AppContext);
	const hasModuleAccess = TokenUtils.hasModuloRepondeur();
	const chat = useRepondeur();
	const { clearVisual, carregarContexto } = chat;
	const logoRef = useRef(null);
	const conversaVazia = chat.messages.length === 0;
	const bloqueado = !acessoLiberado(chat.contexto);

	useEffect(() => {
		carregarContexto();
	}, [carregarContexto]);

	// a logo é uma só: enquanto o chat está vazio ela é levada até a saudação e,
	// na primeira mensagem, volta animada para a barra superior
	useEffect(() => {
		const posicionarLogo = () => {
			const logo = logoRef.current;
			if (!logo) return;

			const destino = document.querySelector(".repondeur-hero-logo-slot");

			// conversa iniciada: volta para a barra superior com a transição ativa
			if (!conversaVazia || !destino) {
				logo.style.transition = "";
				logo.style.transform = "";
				return;
			}

			// posiciona sobre a saudação sem animar, medindo a posição natural com a
			// transição desligada para não medir a logo em movimento
			logo.style.transition = "none";
			logo.style.transform = "";

			const atual = logo.getBoundingClientRect();
			const alvo = destino.getBoundingClientRect();
			if (!atual.height || !alvo.height) {
				logo.style.transition = "";
				return;
			}

			const escala = alvo.height / atual.height;
			const deslocamentoX = alvo.left + alvo.width / 2 - (atual.left + atual.width / 2);
			const deslocamentoY = alvo.top + alvo.height / 2 - (atual.top + atual.height / 2);
			logo.style.transform =
				"translate(" + deslocamentoX + "px, " + deslocamentoY + "px) scale(" + escala + ")";
			void logo.offsetWidth;
			logo.style.transition = "";
		};

		posicionarLogo();
		window.addEventListener("resize", posicionarLogo);

		// o herói se reorganiza depois da montagem (carregamento de fontes, tamanho
		// do título variável), então a posição precisa ser recalculada
		let observador = null;
		const alvo = document.querySelector(".repondeur-hero");
		if (alvo && typeof window.ResizeObserver === "function") {
			observador = new window.ResizeObserver(posicionarLogo);
			observador.observe(alvo);
		}
		if (document.fonts && document.fonts.ready) {
			document.fonts.ready.then(posicionarLogo);
		}

		return () => {
			window.removeEventListener("resize", posicionarLogo);
			if (observador) observador.disconnect();
		};
	}, [conversaVazia, bloqueado, context.userSession]);

	useEffect(() => {
		redirectPage(sessionStorage.getItem("token"), "/repondeur");
		return clearVisual;
	}, [clearVisual]);

	if (!context.userSession) {
		return (
			<div id="main-body" className="container">
				<div className="text-center mt-5">
					<h3>Carregando...</h3>
				</div>
			</div>
		);
	}

	if (!hasModuleAccess) {
		return <Redirect to="/home" />;
	}

	return (
		<div className="x-body repondeur-page" id="main-body">
			<main>
				<div className="x-web-ordering__container">
					<section className="x-web-ordering__left">
						<div className="repondeur-toolbar">
							<div className="repondeur-back">
								<Back />
							</div>
							<div className="repondeur-logo-wrap">
								<img
									ref={logoRef}
									className="repondeur-logo"
									src={logoResponde}
									alt="Conecta Responde"
									onLoad={() => window.dispatchEvent(new Event("resize"))}
								/>
							</div>
						</div>
						<div className="repondeur-chat-area">
							{bloqueado ? (
								<div className="repondeur-bloqueado">
									<p>O Conecta Responde ainda não está configurado para o seu papel.</p>
									<p>Fale com o administrador da sua conta para liberar o acesso.</p>
								</div>
							) : (
								<ChatWindow chat={chat} />
							)}
						</div>
					</section>
				</div>
			</main>
		</div>
	);
};

export default Repondeur;
